/**
 * 自营老户升级页面
 */
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import isPrerendering from '@/shared/utils/isPrerendering';
import HomeBottomBar from '@/components/home-bottom-bar';
import { Notify } from 'vant';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import FinanceBusiness from '@/mixins/finance-business';
import { RouterV2Enum } from '@/router/router-names';
import { upgradeUserInfosKey } from '@/constant/user';
import AdvertDialog from '@/mixins/advert-dialog';
import { HomeThemeEnums } from '@/shared/utils/pageTheme';
import platform from '@/shared/utils/platform';
import { styleNumPxToVm } from '@/shared/utils/style-unit';
import store from '@/store';
import RepayItem from '@/views_v2/home/components/repay-item/index.vue';
import MessageNoticeBar from '@/pages/home/components/MessageNoticeBar/index.vue';
import PocketMoneyCard from '@/pages/home/components/PocketMoneyCard/index.vue';
import RiskStatement from '../../components/risk-statement';
import AutarkyUpgradeCard from '../../components/autarky-upgrade-card';
import { formatCreditAmount } from '../../components/utils';
import Autarkey from '../../autarky';

// 快速提现卡片组件 - 异步导入
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const QuickWithdrawCard = () => import(
  /* webpackChunkName: "quick-withdraw-card" */'@/components/quick-withdraw-card/index.vue'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const style: Dictionary = require('./index.module.scss');


const _isPrerendering = isPrerendering();
const HomeStore = namespace('home');

@Component
export default class UpgradeWrapper extends Mixins(
  FinanceBusiness,
  AdvertDialog,
  Autarkey,
) {
  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.State homeThemeType!: HomeThemeEnums | null;

  @HomeStore.Getter isExperimentA!: boolean;

  // 点击提现
  private async withdraw() {
    await this.getCreditData();
    if (this.isUpgradeSucceed) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Notify('已升级成功即将跳转页面');
      localStorage.setItem(upgradeUserInfosKey, JSON.stringify({
        // 一次性弹框，弹过后续就不需要再弹
        needToast: false,
      }));
      setTimeout(() => {
        this.loan();
      }, 1000);
    } else {
      this.loan();
    }
  }

  // 去提现
  private loan() {
    const buttonName = `finance_upgradeAPage_loan${this.isUpgradeSubmit ? '_process' : ''}`;
    // 有可用额度跳转提现页，否则跳转首页
    if (this.creditData && this.creditData.creditAmount !== 0) {
      this.onApplyProduct(buttonName);
    } else {
      this.$ubtPageButton(buttonName);
      this.$router.replace({
        path: RouterV2Enum.home,
      });
    }
  }

  // 检查快速提现卡片弹窗是否显示并关闭
  public async checkAndCloseQuickWithdrawCard(): Promise<boolean> {
    const quickWithdrawCard = this.$refs.quickWithdrawCardRef as {
      closePopup?: () => Promise<boolean>;
    } | undefined;

    if (quickWithdrawCard && typeof quickWithdrawCard.closePopup === 'function') {
      const hasClosed = await quickWithdrawCard.closePopup();
      return hasClosed;
    }
    return false; // 没有弹窗或未关闭
  }

  private created() {
    if (this.isUpgradeSubmit) {
      this.$ubtModuleExpose('finance_upgradeAPage_process');
    } else {
      this.$ubtModuleExpose('finance_upgradeAPage_landing');
    }
  }

  private render() {
    /** 是否可用的授信额度 */
    const isAvailableCreditAmount = this.creditData && Number(this.creditData.creditAmount) !== 0;
    /** 是否展示提现bar */
    const isDisplayWithdraw = isAvailableCreditAmount && !this.isExperimentA;
    /** 是否展示还款订单bar */
    const isDisplayNeedRepayOrder = !!(this.creditData && this.creditData.needRepayOrderNum);

    return (
      <div
        class={style.upgradeWrapper}
      >
        {this.creditData && (
          <MessageNoticeBar
            userCreditData={this.creditData}
            className={'homeMessageNoticeBarWrapper upgradeWrapper'}
          />
        )}
        <AutarkyUpgradeCard
          onLoan={this.loan.bind(this)}
        />
        {(isDisplayWithdraw || isDisplayNeedRepayOrder) && (
          <div class={style.operate}>
            {isDisplayWithdraw && (
              <div class={style.operateItem} onClick={this.withdraw.bind(this)}>
                <span>
                  可提现额度
                  <span class={style.numberFont}>
                    {` ${formatCreditAmount(this.creditData.creditAmount, 0)}`}
                  </span>
                </span>
                <span class={style.right}>
                  去提现<RightArrowOutline12 class={style.iconSize} />
                </span>
              </div>
            )}
            {/** 此分割线是为了让“提现bar”和“还款订单bar”分开，若两者不同时存在，则无需分割线 */}
            {(isDisplayWithdraw && isDisplayNeedRepayOrder) && <div class={style.split} />}
            {isDisplayNeedRepayOrder && <div class={style.operateItem}>
              <RepayItem/>
            </div>}
          </div>
        )}
        {this.creditData && (
          <PocketMoneyCard
            userCreditData={this.creditData}
          />
        )}
        {/* 主要用于命中用户返回的时候显示广告弹窗，见：popup.tsx */}
        {!_isPrerendering && this.renderAdvertDialog()}
        <RiskStatement
          class={style.bootomRiskStatement}
          style={
            platform.isIOS && !store.state.base.isHybridAppMode
              ? { paddingBottom: `${styleNumPxToVm(52)}vw` }
              : null
          }
        />
        {!_isPrerendering && (
          <HomeBottomBar currentPage={'qualityHomePage'}/>
        )}

        {/* 快速提现卡片组件 - 完全内聚，无需外部事件处理 */}
        {this.creditData && (
          <QuickWithdrawCard
            ref="quickWithdrawCardRef"
            userCreditData={this.creditData}
          />
        )}
      </div>
    );
  }
}
